import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VERSION } from '../../app.constants';
import { LoginPageDetails } from '../../shared/login/login.model';
import { LoginContext } from '../../shared/login/login-context';
import { Subscription } from 'rxjs';
import { ApproveRequest, PckeAuthorizationService } from '../../shared/auth/pcke-authorization.service';

@Component({
    selector: 'jhi-one-time-password',
    templateUrl: './authorize-login.component.html',
    styleUrls: [
        '../login.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export class AuthorizeLoginComponent implements OnInit, OnDestroy {

    version = VERSION;
    pageDetails: LoginPageDetails;
    otpCode: string;

    formInvalid = 'login-form-invalid';

    display_name: string;
    return_url: string;
    client_id: string;
    redirect_uri: string;
    code_challenge: string;
    code_challenge_method: string;
    state: string;

    private queryParamSubscription: Subscription;

    constructor(private context: LoginContext,
                private route: ActivatedRoute,
                private pckeAuthorizationService: PckeAuthorizationService
    ) {
        document.body.classList.add('body-container');
        this.queryParamSubscription = this.route.queryParams.subscribe((params) => {
            this.display_name = params['display_name'];
            this.return_url = params['return_url'];
            this.client_id = params['client_id'];
            this.redirect_uri = params['redirect_uri'];
            this.code_challenge = params['code_challenge'];
            this.code_challenge_method = params['code_challenge_method'];
            this.state = params['state'];
        });
    }

    ngOnInit(): void {
        this.pageDetails = this.context.pageDetails;
    }

    async doAuthorizeSubmit() {

        const approveRequest: ApproveRequest = {
            clientId: this.client_id,
            redirectUri: this.redirect_uri,
            codeChallenge: this.code_challenge,
            codeChallengeMethod: this.code_challenge_method,
            state: this.state
        };

        return await this.pckeAuthorizationService.doAuthorizeSubmit(approveRequest);
    }

    ngOnDestroy(): void {
        document.body.classList.remove('body-container');
        this.queryParamSubscription.unsubscribe();
    }
}
